import di from 'di'

import defaultConfig from '@/js/config/config.default';

function configFromEnv() {    
    const runtimeConfig = (typeof window !== 'undefined' && window.APP_CONFIG) || {};    

    return {
        basePath: '',

        apiUrl: runtimeConfig.API_URL + '/api',

        realtime: {
            host: runtimeConfig.API_URL,
            path: '/api/realtime/'
        },

        suppressExitAlerts: false
    };
}

export default function(){

    const ENV = import.meta.env.MODE;

    let config = defaultConfig;
    let envConfig = configFromEnv();

    Object.assign(config, envConfig);
    di.set('config', config);
}